/**
 * 酪蛋白产业链数字化（/industry-chain）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C/$CList 读取。
 * 默认值来自 src/data/industryChain.js，与页面当前内置内容保持一致，未配置时页面外观不变。
 */
import {
  SIDE_LABELS, DECISION_ITEMS, SYSTEMS, MOM_GROUPS, PLATFORM_ITEMS,
  PLATFORM_BRAND_A, PLATFORM_BRAND_B, INFRA_TEXT, NETWORK_ITEMS,
  DEVICE_ITEMS, GUARD1_TEXT, GUARD2_TEXT,
} from '@/data/industryChain'

export default {
  title: '酪蛋白产业链数字化',
  groups: [
    {
      title: '左侧层级标签',
      fields: [
        { key: 'sideLabels', label: '层级标签（含高度配比）', type: 'array', default: SIDE_LABELS },
      ],
    },
    {
      title: '智慧决策',
      fields: [
        { key: 'decisionItems', label: '智慧决策模块项', type: 'array', default: DECISION_ITEMS },
      ],
    },
    {
      title: '系统集成',
      fields: [
        { key: 'systems', label: '系统集成系统项', type: 'array', default: SYSTEMS },
      ],
    },
    {
      title: 'MOM制造运营系统',
      fields: [
        { key: 'momGroups', label: 'MOM 分组与模块', type: 'array', default: MOM_GROUPS },
      ],
    },
    {
      title: '平台层',
      fields: [
        { key: 'platformItems', label: '平台层能力项', type: 'array', default: PLATFORM_ITEMS },
        { key: 'platformBrandA', label: '平台层品牌文字·上行', type: 'text', default: PLATFORM_BRAND_A },
        { key: 'platformBrandB', label: '平台层品牌文字·下行', type: 'text', default: PLATFORM_BRAND_B },
        { key: 'infraText', label: '基础设施说明文字', type: 'textarea', default: INFRA_TEXT },
      ],
    },
    {
      title: '网络传输',
      fields: [
        { key: 'networkItems', label: '网络传输方式项', type: 'array', default: NETWORK_ITEMS },
      ],
    },
    {
      title: '设备层',
      fields: [
        { key: 'deviceItems', label: '设备层设备项', type: 'array', default: DEVICE_ITEMS },
      ],
    },
    {
      title: '右侧安全控制',
      fields: [
        { key: 'guard1Text', label: '安全控制条·统一', type: 'text', default: GUARD1_TEXT },
        { key: 'guard2Text', label: '安全控制条·厂家', type: 'text', default: GUARD2_TEXT },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认透明）', type: 'image', default: '' },
      ],
    },
  ],
}
